function DDUFooterABS({value}) {
    return (
        <div class="relative flex items-center justify-center border-[#fffa7d] border-[2px] rounded-[10px] text-[#fffa7d]">
            <p class={`${value["pit-limiter"] === 1 ? "bg-[#0743c2]" : "bg-[#0a0f14]"} absolute top-[-13px] text-[12px] px-3 py-1 uppercase font-bold`}>ABS</p>
            <h1 class="text-[40px] font-bold">{value.abs}</h1>
        </div>
    );
}

export default DDUFooterABS;